//******************************************************************************
/**
 * @fileoverview FileFetcher LinePNG用ファイル取得の基底クラス
 * @author KITAO Kaoru <kaoru@kitao.net>
 * @version 0.1.1
 * @since 2026-02-04
 * @copyright 2026 AIST/GSJ
 * @license MIT
 * * @history
 * - 2026.02.21 v0.1.1 クラス名変更
 * - 2026.02.04 v0.1.0 リリース
 */

//******************************************************************************
// import
import { RangeChunkFetcher } from "range-chunk-fetcher";

//******************************************************************************
/**
 * 基底クラスの定義（コンストラクタとgetJsonメソッドは共通）
 */
class FileFetcherBase {
	//**************************************************************************
	/**
	 * コンストラクタ
	 */
	constructor() {
		this.fetcher = new RangeChunkFetcher();
	}

	//**************************************************************************
	/**
	 * JSONファイルを取得してパース結果を返す
	 * @param {string} path
	 * @returns {Promise<Object>}
	 */
	async getJson(path) {
		const buffer = await this.fetcher.fetch(path);
		const jsonString = new TextDecoder().decode(new Uint8Array(buffer));
		return JSON.parse(jsonString);
	}
};

//******************************************************************************
// export
export { FileFetcherBase };
